import { isNumber } from 'lodash'
import { AccountErrorCodeEnum } from '../shared/mycicero-web-api/shared/base-login-output.model'

export enum AccountStatus {
  unknown,
  active,
  unconfirmed,
  disabled,
  blocked,
  ambiguous,
  closing,
  uncompleted, // TODO: Need BE to implement this status
  needAcceptConsents,
  needChangePassword,
}

type AccountErrorCodes = Exclude<
  (typeof AccountErrorCodeEnum)[keyof typeof AccountErrorCodeEnum],
  AccountErrorCodeEnum.wrongCredentials | AccountErrorCodeEnum.unauthorized
>

const errorCodeToAccountStatus: Record<AccountErrorCodes, AccountStatus> = {
  [AccountErrorCodeEnum.unhandled]: AccountStatus.unknown,
  [AccountErrorCodeEnum.genericError]: AccountStatus.unknown,
  [AccountErrorCodeEnum.userDataSynchronisationError]: AccountStatus.unknown,
  [AccountErrorCodeEnum.actionRequired]: AccountStatus.unknown,
  [AccountErrorCodeEnum.userNotFound]: AccountStatus.unknown,
  [AccountErrorCodeEnum.userNotConfirmed]: AccountStatus.unconfirmed,
  [AccountErrorCodeEnum.userDisabled]: AccountStatus.disabled,
  [AccountErrorCodeEnum.userClosed]: AccountStatus.closing,
  [AccountErrorCodeEnum.userInBlackList]: AccountStatus.blocked,
  [AccountErrorCodeEnum.ambiguousCredentials]: AccountStatus.ambiguous,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAccountStatus = (value: any): value is AccountStatus => !!(isNumber(value) && AccountStatus[value])

export const getAccountStatusFromErrorCode = (codeError: AccountErrorCodeEnum): AccountStatus =>
  errorCodeToAccountStatus[codeError] ?? null
